import React from 'react';
import { Trophy } from 'lucide-react';

export default function Achievements() {
    return (
        <section id="achievements" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500 flex items-center gap-2">
                <Trophy className="text-yellow-500" size={24} />
                SCHOLASTIC ACHIEVEMENTS
            </h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <ul className="space-y-4">
                    <li className="flex flex-col md:flex-row md:justify-between">
                        <span className="font-medium text-base sm:text-lg">
                            Secured Second Place in NPCI AI Hackathon on Synthetic AEPS Data, NPCI Hyderabad
                        </span>
                        <span className="text-gray-600 mt-1 md:mt-0 text-sm sm:text-base">Jul'24</span>
                    </li>
                    <li className="flex flex-col md:flex-row md:justify-between">
                        <span className="font-medium text-base sm:text-lg">
                            Secured Second Place in Capture the Flag (CTF) Challenge in Network Security course, IIT Hyderabad
                        </span>
                        <span className="text-gray-600 mt-1 md:mt-0 text-sm sm:text-base">Apr'24</span>
                    </li>
                </ul>
            </div>
        </section>
    );
}
